module.exports = __webpack_public_path__ + "static/media/bg_judge.9c77bb9d.png";